import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { AppService } from '../../services/app.service';

declare var screen_index: any;

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  screens:any[] = [];
  loading:boolean = true;
  MACHINE_ID:string = '';
  constructor(private router:Router, private appservice:AppService,private activatedRoute: ActivatedRoute) {
    this.MACHINE_ID = this.appservice.getMachineId();
  }

  
  
  ngOnInit() {

      let last_screen_id = this.appservice.getLastScreenId();
    
      let screen_id = null;
      let screens_aux = this.appservice.getScreens();
      if(typeof(screen_index) != 'undefined' && screen_index != null){
        screens_aux.forEach( (s,index) => {
         
          if(index == screen_index){
            
            if(this.appservice.isConnected(s.id)){
              screen_id = s.id;
              console.log("FOUND INDEX > "+s.name);
              
            }
          }
        });
      }

      

      if(screen_id == null && typeof(last_screen_id) != 'undefined' && last_screen_id != ''){
        screens_aux.forEach( (s) => {
      
          if(last_screen_id == s.id){
            if(this.appservice.isConnected(s.id)){
              screen_id = s.id;
            }
          }
        });
      }
      
      if(screen_id != null){
        this.router.navigate(['streaming/'+screen_id]);
      }else{
        if(screens_aux.length){
          screens_aux.forEach( (s) => {
            if(this.appservice.isConnected(s.id)){
              this.screens.push(s);
            }else{
              this.appservice.removeScreen(s.id);
            }
          });

        }
        if(!this.screens.length){
          this.router.navigate(['configure']);
        }
        this.loading = false;
      }
    
    
  }



  removeScreen(sid){
    this.appservice.removeScreen(sid);
    this.screens = this.appservice.getScreens();

  }

}



// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/components/index/index.component.ts